import * as React from "react";
import {useEffect, useState} from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import "./MainMenu.css";
import clsx from "clsx";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import Popover from "@mui/material/Popover";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {Stack} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import jwt_decode from "jwt-decode";
import Button from "@mui/material/Button";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import Badge from "@mui/material/Badge";
import {NavLink, useNavigate} from "react-router-dom";
import {apiGet, apiPut} from "../utils/apiRequests";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

import {adminPathLocations, pathLocations, PlayerPathLocations,} from "../utils/pathLocations";
import ApiEndpoints from "../utils/ApiEndpoints";
import {useDispatch, useSelector} from "react-redux";
import {handleDrawerToggle} from "../redux/actions/theme-action";
import {BASE_URL} from "../constant/apiURL";
import {toast} from "react-toastify";

const LOGO = require("../assets/images/drawer-logo.png");

const user_placeholder = require("../assets/images/user_placeholder.png");

const menuStyles = makeStyles({
    mainContainer: {
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#F5F5F5",
        display: "flex",
    },
    leftSide: {
        height: "100%",
        backgroundColor: "#fff",
        borderRight: "1px solid #DAE5EA",
    },
    rightSide: {
        position: "relative",
    },
    header: {
        width: "100%",
        height: "70px",
        backgroundColor: "#fff",
    },
    children: {
        width: "100%",
        maxHeight: "90%",
        backgroundColor: "red",
        overflowX: "hidden",
        overFlowY: "scroll",
    },
    footer: {
        width: "100%",
        height: "70px",
        backgroundColor: "#fff",
        position: "absolute",
        bottom: 0,
        left: 0,
    },
    appLogo: {
        width: "100px",
    },
    userIcon: {
        margin: 10,
        cursor: "pointer",
    },
    bellIcon: {
        margin: 10,
        cursor: "pointer",
    },
    headerUserIcon: {
        color: "#2C633C !important",
        padding: "4px  !important",
        "&:hover": {},
    },
    breadcrumbsBox: {
        padding: 17,
        paddingBottom: 1,
        "& a:hover": {
            color: "black",
        },
    },

    menuItemText: {
        color: "black",
        fontSize: "14px !important",
        marginLeft: "10px !important",
        fontWeight: "500 !important",
    },
    activeMenuItem: {
        background: "#06623B !important",
        padding: "0px 15px  !important",
        marginLeft: "-14px  !important",
        marginRight: "-14px  !important",
        borderRight: "1px solid green  !important",
        borderRadius: "11px  !important",
        color: "white",
        "&  span": {
            color: "white",
        },
    },
    userNameHeading: {
        color: "#06623B",
        fontWeight: "900px",
    },
    popoverColor: {
        color: "#06623B",
    },
    popoverBtn1: {
        backgroundColor: "#2C633C !important",
    },
    popoverBtn2: {
        backgroundColor: "#FF0000 !important",
    },
    popoverNotificationIcon: {
        color: "#2C633C",
        fontSize: "34px !important",
        alignSelf: "center !important",
    },
    MenuListItem: {
        flexDirection: "column",
        "&:hover": {
            padding: "0px 15px  !important",
            borderRadius: "11px  !important",
        },
    },

    menuSubNavItemText: {
        width: "fit-content",
        maxWidth: "fit-content",
        paddingRight: "0",
        "& span": {
            width: "fit-content",
        },
    },

    MenuListItemButton: {
        width: "100%",
        borderRadius: "11px",
        marginBottom: "10px",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        padding: "10px 15px",
        cursor: "pointer",
        "&:hover": {
            background: "rgba(0, 0, 0, 0.04)",
        },
    },
    MenuListItemButtonActive: {
        width: "100%",
        borderRadius: "10px",
        marginBottom: "10px",
        textDecoration: "none",
        display: "flex",
        background: "#06623B",
        padding: "10px 15px",
        alignItems: "center",
        "&:hover": {
            borderRadius: "11px  !important",
        },
        "& > p": {
            color: "white",
            fontWeight: "700 !important",
        },
    },

    SubMenuListItemButton: {
        width: "80%",
        borderRadius: "11px",
        marginBottom: "10px",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        padding: "10px 15px",
        cursor: "pointer",
        margin: "0px auto",
        "&:hover": {
            background: "rgba(0, 0, 0, 0.04)",
        },
    },

    SubMenuListItemButtonActive: {
        width: "80%",
        borderRadius: "11px",
        marginBottom: "10px",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        background: "#06623B",
        padding: "10px 15px",
        cursor: "pointer",
        margin: "0px auto",
        "& > p": {
            color: "white",
            fontWeight: "700 !important",
        },
    },

    MenuSubNavListItemButton: {
        width: "159px",
    },
    MenuItemImage: {
        height: 24,
        width: 24,
    },
    MenuItemIcon: {
        backgroundColor: "red",
        width: 24,
        zIndex: 1,
        minWidth: "24px !important",
    },
    MenuSubNavActive: {
        marginLeft: "5%",
    },
});

function SubNavLinks(props) {
    const {openSubNav, children, to} = props;
    const classes = menuStyles();

    return (
        <Collapse
            in={openSubNav}
            unmountOnExit
            className={clsx({
                [classes.MenuSubNavActive]: openSubNav,
            })}
        >
            <List component="div" disablePadding>
                {children.map((item, index) => (
                    <NavLink
                        className={({isActive}) =>
                            isActive
                                ? classes.SubMenuListItemButtonActive
                                : classes.SubMenuListItemButton
                        }
                        to={item?.link}
                        key={index}
                    >
                        <img
                            src={item.icon}
                            alt={item.title}
                            className={classes.MenuItemImage}
                        />
                        <Typography className={classes.menuItemText}>
                            {item.title}
                        </Typography>
                    </NavLink>
                ))}
            </List>
        </Collapse>
    );
}

function SideNavBar(props) {
    const {handleNavMenuOnClick, openSubNavItem, SideNavWidth} = props;
    const classes = menuStyles();

    const role = useSelector((state) => state?.userDetailsReducer?.role);

    return (
        <div>
            <List
                component="nav"
                sx={{
                    width: SideNavWidth,
                    overflowX: "hidden",
                    padding: "40px 10px",
                    display: SideNavWidth === 0 ? "none" : "block",
                }}
            >
                {role === "super" ? (
                    <>
                        {pathLocations.map((item, index) => {
                            if (item.icon && item.isEnabled)
                                return (
                                    <>
                                        {item?.children?.length > 0 ? (
                                            <>
                                                <ListItem
                                                    key={index}
                                                    className={classes.MenuListItemButton}
                                                    sx={{justifyContent: "space-between"}}
                                                    onClick={() => handleNavMenuOnClick(item.title)}
                                                >
                                                    <Box sx={{display: "flex", alignItems: "center"}}>
                                                        <img
                                                            src={item.icon}
                                                            alt={item.title}
                                                            className={classes.MenuItemImage}
                                                        />
                                                        <Typography className={classes.menuItemText}>
                                                            {item.title}
                                                        </Typography>
                                                    </Box>
                                                    <ExpandMore/>
                                                </ListItem>
                                                {item.children?.length > 0 && (
                                                    <SubNavLinks
                                                        children={item.children}
                                                        openSubNav={openSubNavItem === item.title}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            <NavLink
                                                className={({isActive}) =>
                                                    isActive
                                                        ? classes.MenuListItemButtonActive
                                                        : classes.MenuListItemButton
                                                }
                                                to={item?.link}
                                                key={index}
                                            >
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className={classes.MenuItemImage}
                                                />
                                                <Typography className={classes.menuItemText}>
                                                    {item.title}
                                                </Typography>
                                            </NavLink>
                                        )}
                                    </>
                                );
                        })}
                    </>
                ) : role === "admin" ? (
                    <>
                        {adminPathLocations.map((item, index) => {
                            if (item.icon && item.isEnabled)
                                return (
                                    <>
                                        {item?.children?.length > 0 ? (
                                            <>
                                                <ListItem
                                                    key={index}
                                                    className={classes.MenuListItemButton}
                                                    sx={{justifyContent: "space-between"}}
                                                    onClick={() => handleNavMenuOnClick(item.title)}
                                                >
                                                    <Box sx={{display: "flex", alignItems: "center"}}>
                                                        <img
                                                            src={item.icon}
                                                            alt={item.title}
                                                            className={classes.MenuItemImage}
                                                        />
                                                        <Typography className={classes.menuItemText}>
                                                            {item.title}
                                                        </Typography>
                                                    </Box>
                                                    <ExpandMore/>
                                                </ListItem>
                                                {item.children?.length > 0 && (
                                                    <SubNavLinks
                                                        children={item.children}
                                                        openSubNav={openSubNavItem === item.title}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            <NavLink
                                                className={({isActive}) =>
                                                    isActive
                                                        ? classes.MenuListItemButtonActive
                                                        : classes.MenuListItemButton
                                                }
                                                to={item?.link}
                                                key={index}
                                            >
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className={classes.MenuItemImage}
                                                />
                                                <Typography className={classes.menuItemText}>
                                                    {item.title}
                                                </Typography>
                                            </NavLink>
                                        )}
                                    </>
                                );
                        })}
                    </>
                ) : (
                    <>
                        {PlayerPathLocations.map((item, index) => {
                            if (item.icon && item.isEnabled)
                                return (
                                    <>
                                        {item?.children?.length > 0 ? (
                                            <>
                                                <ListItem
                                                    key={index}
                                                    className={classes.MenuListItemButton}
                                                    sx={{justifyContent: "space-between"}}
                                                    onClick={() => handleNavMenuOnClick(item.title)}
                                                >
                                                    <Box sx={{display: "flex", alignItems: "center"}}>
                                                        <img
                                                            src={item.icon}
                                                            alt={item.title}
                                                            className={classes.MenuItemImage}
                                                        />
                                                        <Typography className={classes.menuItemText}>
                                                            {item.title}
                                                        </Typography>
                                                    </Box>
                                                    <ExpandMore/>
                                                </ListItem>
                                                {item.children?.length > 0 && (
                                                    <SubNavLinks
                                                        children={item.children}
                                                        openSubNav={openSubNavItem === item.title}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            <NavLink
                                                className={({isActive}) =>
                                                    isActive
                                                        ? classes.MenuListItemButtonActive
                                                        : classes.MenuListItemButton
                                                }
                                                to={item?.link}
                                                key={index}
                                            >
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className={classes.MenuItemImage}
                                                />
                                                <Typography className={classes.menuItemText}>
                                                    {item.title}
                                                </Typography>
                                            </NavLink>
                                        )}
                                    </>
                                );
                        })}
                    </>
                )}
            </List>
        </div>
    );
}

function HeaderUserIcon({id, onclickHandler, showBadge, children}) {
    const classes = menuStyles();

    return (
        <Badge
            color="error"
            variant="dot"
            invisible={!showBadge}
            overlap="circular"
        >
            <IconButton
                size="large"
                aria-describedby={id}
                onClick={onclickHandler}
                className={classes.headerUserIcon}
            >
                {children}
            </IconButton>
        </Badge>
    );
}

function CustomPopover(props) {
    const {id, open, anchorElement, onClose} = props;
    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorElement}
            onClose={onClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            PaperProps={{
                style: {
                    height: "auto",
                    maxHeight: "50vh",
                },
            }}
            {...props}
        >
            {props.children}
        </Popover>
    );
}

function MainMenu(props) {
    // Selectors

    const dispatch = useDispatch();

    //#region States
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [openSubNavItem, setopenSubNavItem] = React.useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
    const [accountSttingEl, setAccountSettingEl] = useState(null);
    const [hideNotificationBadge, setHideNotificationBadge] = useState(false);
    const [playerData, setPlayerData] = useState();
    const [playerNotifications, setPlayerNotifications] = useState([]);
    const [playerNotificationsUnread, setPlayerNotificationsUnread] =
        useState(false);
    const [sideNavWidth, setSideNavWidth] = useState(300);
    //#endregion

    //#region variable declarations
    const navigate = useNavigate();
    const classes = menuStyles();
    const token = localStorage.getItem("token");
    var decodedToken = jwt_decode(token);
    const userFirstName = decodedToken?.firstName;
    const userLastName = decodedToken?.lastName;
    const open = anchorEl;
    const id = open ? "simple-popover" : undefined;
    const openAccSettingPopover = accountSttingEl;
    const accSettingElId = openAccSettingPopover ? "simple-popover" : undefined;

    const getPlayerDetails = () => {
        apiGet(
            `${ApiEndpoints.user.base}/basic-info`,
            (res) => {
                setPlayerData(res?.data);
                setPlayerNotifications(res?.data?.notifications);
                trv_notifications();
            },
            (err) => console.log("getPlayerDetails Error: ", err.message)
        );
    };

    React.useEffect(() => {
        getPlayerDetails();
    }, []);

    const checkDimesion = () => {
        if (window.innerWidth >= 1200) {
            setSideNavWidth(300);
        } else {
            setSideNavWidth(0);
        }
    };

    useEffect(() => {
        checkDimesion();
    }, []);

    window.addEventListener("resize", () => {
        checkDimesion();
    });

    //#endregion

    //#region Methods
    const handlePopOverClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopOverClose = () => {
        setAnchorEl(null);
    };

    const handleNotificationPopoverClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleCloseNotificationPopoverModal = () => {
        setNotificationAnchorEl(null);
    };

    const handleAccSettingPopoverClick = (event) => {
        navigate("/playerAccount", {replace: false, state: {playerData}});
    };

    const _handleNotificationAction = (tournamentID, status) => {

        apiPut(
            `${ApiEndpoints.user.base}${ApiEndpoints.user.tournamentParticipation}${tournamentID}`,
            {status},
            (res) => {

                if (res.error) {
                    toast.error(res.message);
                } else {
                    toast.success(res.message);
                    getPlayerDetails();
                }
            },
            (err) => console.log("getPlayerDetails Error: ", err.message)
        );
    };
    const openNotificationPopover = notificationAnchorEl;
    const notificationPopoverId = openNotificationPopover
        ? "simple-popover"
        : undefined;

    const closeAccSettingPopoverClick = () => {
        setAccountSettingEl(null);
    };

    const trv_notifications = () => {
        if (playerNotifications.length > 0) {
            if (playerNotifications.find((n) => n.isRead === false)) {
                setPlayerNotificationsUnread(true);
            } else {
                setPlayerNotificationsUnread(false);
            }
        }
    };
    const onLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    const _handleNavMenuOnClick = (name) => {
        if (openSubNavItem === name) setopenSubNavItem("");
        else setopenSubNavItem(name);
    };

    const handleToggle = () => {
        dispatch(handleDrawerToggle(true));
    };

    //#endregion

    React.useEffect(() => {
        getPlayerDetails();
        setHideNotificationBadge(false);
    }, []);
    useEffect(() => {
        trv_notifications();
    }, [playerNotifications]);
    return (
        <>
            <CssBaseline/>
            <Box
                sx={{
                    display: "flex",
                    backgroundColor: "#F5F5F5",
                    minHeight: "100%",
                    overflowY: "hidden",
                }}
            >
                <CssBaseline/>
                <AppBar
                    position="fixed"
                    sx={{
                        // zIndex: (theme) => theme.zIndex.drawer + 1,
                        boxShadow:
                            "0px 0px 0px -1px rgb(0 0 0 / 20%), 0px 1px 0px 0px rgb(0 0 0 / 14%), 0px 1px 0px 0px rgb(0 0 0 / 12%)",
                    }}
                >
                    <Toolbar sx={{backgroundColor: "#fff"}}>
                        <Grid container xs={12}>
                            <Grid item xs={2}>
                                <Box sx={{m: 2}}>
                                    <img src={LOGO} alt="app-logo" className={classes.appLogo}/>
                                </Box>
                            </Grid>
                            <Grid
                                item
                                container
                                xs={10}
                                justifyContent={"flex-end"}
                                alignItems={"center"}
                            >
                                <HeaderUserIcon
                                    id={id}
                                    onclickHandler={handleNotificationPopoverClick}
                                    showBadge={playerNotificationsUnread}
                                >
                                    <NotificationsIcon fontSize="inherit"/>
                                </HeaderUserIcon>
                                <HeaderUserIcon
                                    id={id + "1"}
                                    onclickHandler={handlePopOverClick}
                                >
                                    <PersonRoundedIcon fontSize="inherit"/>
                                </HeaderUserIcon>

                                <CustomPopover
                                    id={id}
                                    open={open}
                                    anchorElement={anchorEl}
                                    onClose={handlePopOverClose}
                                >
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Grid
                                                item
                                                container
                                                xs={12}
                                                sx={{display: "flex", justifyContent: "center"}}
                                            >
                                                <Avatar
                                                    alt="user profile picture"
                                                    src={
                                                        playerData?.image
                                                            ? `${BASE_URL}${playerData?.image}`
                                                            : user_placeholder
                                                    }
                                                    sx={{width: "125px", height: "125px", mt: 1}}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                container
                                                xs={12}
                                                justifyContent="center"
                                                alignItems="center"
                                                mt={2}
                                            >
                                                <Typography
                                                    variant="h6"
                                                    className={classes.userNameHeading}
                                                >
                                                    {`${userFirstName} ${userLastName}`}
                                                </Typography>

                                                <Grid
                                                    item
                                                    container
                                                    xs={12}
                                                    sx={{
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                    }}
                                                    mt={1}
                                                >
                                                    <Grid item xs={2}>
                                                        <SettingsOutlinedIcon
                                                            className={[classes.popoverColor]}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Typography
                                                            className={[classes.popoverColor]}
                                                            onClick={handleAccSettingPopoverClick}
                                                        >
                                                            Account Settings
                                                        </Typography>

                                                        <Popover
                                                            open={openAccSettingPopover}
                                                            anchorEl={accSettingElId}
                                                            onClose={closeAccSettingPopoverClick}
                                                            anchorOrigin={{
                                                                vertical: "bottom",
                                                                horizontal: "right",
                                                            }}
                                                        >
                                                            <Typography sx={{p: 2}}>
                                                                Coming Soon..
                                                            </Typography>
                                                        </Popover>
                                                    </Grid>
                                                </Grid>

                                                <Grid
                                                    container
                                                    xs={12}
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    sx={{
                                                        cursor: "pointer",
                                                    }}
                                                    mb={2}
                                                >
                                                    <Stack direction="row">
                                                        <ArrowRightAltOutlinedIcon
                                                            className={[classes.popoverColor]}
                                                        />
                                                        <Divider
                                                            orientation="vertical"
                                                            sx={{
                                                                height: "13px !important",
                                                                margin: "5px",
                                                                backgroundColor: "black",
                                                            }}
                                                        />
                                                        <Typography
                                                            className={[classes.popoverColor]}
                                                            onClick={onLogout}
                                                        >
                                                            Logout
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CustomPopover>
                                <CustomPopover
                                    open={openNotificationPopover}
                                    anchorElement={notificationAnchorEl}
                                    onClose={handleCloseNotificationPopoverModal}
                                    sx={{
                                        left: playerNotificationsUnread ? "30vw" : "0",
                                        right: playerNotificationsUnread ? "5vw" : "0",
                                    }}
                                >
                                    <Grid container marginTop="40px" flexDirection="column">
                                        {playerNotifications.length > 0 &&
                                            playerNotifications.map((notification) => (
                                                <>
                                                    {!notification.isRead ? (
                                                        <>
                                                            <Grid
                                                                item
                                                                xs={11}
                                                                md={10}
                                                                alignSelf="center"
                                                                marginBottom="15px"
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    textAlign="center"
                                                                >
                                                                    {notification?.body}
                                                                </Typography>
                                                                <Stack
                                                                    direction="row"
                                                                    spacing={5}
                                                                    marginTop="10px"
                                                                >
                                                                    <Button
                                                                        variant="contained"
                                                                        className={classes.popoverBtn1}
                                                                        onClick={() =>
                                                                            _handleNotificationAction(
                                                                                notification.tournament_id,
                                                                                "confirmed"
                                                                            )
                                                                        }
                                                                    >
                                                                        Accept
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        className={classes.popoverBtn2}
                                                                        onClick={() =>
                                                                            _handleNotificationAction(
                                                                                notification.tournament_id,
                                                                                "refused"
                                                                            )
                                                                        }
                                                                    >
                                                                        Reject
                                                                    </Button>
                                                                </Stack>
                                                            </Grid>
                                                        </>
                                                    ) : null}
                                                </>
                                            ))}
                                        {!playerNotificationsUnread && (
                                            <Grid container>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sx={{padding: 10}}
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                >
                                                    <NotificationsActiveIcon
                                                        className={classes.popoverNotificationIcon}
                                                    />
                                                    <Typography>No notification yet.</Typography>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </CustomPopover>
                                {sideNavWidth === 0 && (
                                    <Button
                                        onClick={handleToggle}
                                        variant="outlined"
                                        sx={{
                                            minWidth: "24px !important",
                                            borderRadius: "5px",
                                            marginLeft: "10px",
                                        }}
                                    >
                                        <MenuRoundedIcon/>
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Box
                    sx={{
                        width: sideNavWidth,
                        backgroundColor: "#fff",
                        borderRight: "1px solid #DAE5EA",
                        overflowX: "hidden",
                        overFlowY: "auto",
                    }}
                >
                    <Toolbar/>
                    <Box>
                        <SideNavBar
                            SideNavWidth={sideNavWidth}
                            handleNavMenuOnClick={_handleNavMenuOnClick}
                            openSubNavItem={openSubNavItem}
                        />
                    </Box>
                </Box>
                <Box
                    component="main"
                    sx={{flexGrow: 1, p: 3, width: `calc(100% - ${sideNavWidth}px)`}}
                >
                    <Toolbar/>
                    {props.children}
                </Box>
            </Box>
            {/* <Box className={classes.mainContainer}>
        <Box className={classes.leftSide} sx={{ width: sideNavWidth }}></Box>
        <Box
          className={classes.rightSide}
          sx={{ width: `calc(100% - ${sideNavWidth}px)` }}
        >
          <Box className={classes.header}>Header</Box>
          <Box className={classes.children}>
            <Box sx={{ padding: "30px" }}>
              {Array(100)
                .fill(0)
                .map((v, i) => (
                  <Box sx={{ backgroundColor: "white", marginBottom: "10px" }}>
                    {i + 1}
                  </Box>
                ))}
            </Box>
          </Box>
          <Box className={classes.footer}>Footer</Box>
        </Box>
      </Box> */}
        </>
    );
}

export default MainMenu;
